import React from 'react';
import {Button, Modal} from "@gravity-ui/uikit";

import "./Modals.css"

export function DeleteModal({type, name, onDelete, open, setOpen, additionalText = ""}) {
    return (
        <Modal open={open} onClose={() => setOpen(false)}>
            <div className="bmm-modal">
                <p>
                    Вы уверены, что хотите удалить {type} {name && `"${name}"`}{additionalText && ` ${additionalText}`}?
                </p>
                <div className="modal-buttons">
                    <Button onClick={onDelete} view={"flat-danger"}>
                        Да, удалить
                    </Button>
                    <Button onClick={() => setOpen(false)} view={"normal"}>
                        Нет, отменить
                    </Button>
                </div>
            </div>
        </Modal>
    );
}

export function UpdateModal({open, setOpen, children}) {
    return (
        <Modal className="modal-adaptive" open={open} onClose={() => setOpen(false)}>
            <div className="bmm-modal bmm-modal_form">
                {children}
            </div>
        </Modal>
    );
}